import { styled } from '../../../../lib/stitches'

const Tag = styled('div', {
  padding: '0 8px',
  height: '18px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '$gray02',
  color: '$gray14',
  fontSize: '12px',
  lineHeight: '18px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  borderRadius: '9999px',
  cursor: 'pointer',
  transition: '100ms ease all',
  '&:hover': {
    background: '$gray03'
  },
  '&:active': {
    background: '$gray04'
  }
})

export default Tag
